import React from "react"
const skillsData = [
    {
        type: 'Programming Languages',
        list: [
            {
                name: 'Python',
                icon: <i class="devicon-python-plain colored"></i>
            },
            {
                name: 'C++',
                icon: <i className= "devicon-cplusplus-plain colored" ></i>
            },
            {
                name: 'JavaScript',
                icon: <i class="devicon-javascript-plain colored"></i>
            }
        ]

    },
    {
        type: 'Frameworks/Libraries',
        list:[
            {
                name: 'Numpy',
                icon: <i class="devicon-redux-original colored"></i>
            },
            {
                name: 'Pandas',
                icon: <i class="devicon-gradle-plain colored"></i>
            },
            {
                name: 'Matplotlib',
                icon: <i class="devicon-jupyter-plain colored"></i>
            },
            {
                name: 'Seaborn',
                icon: <i class="devicon-gitter-plain colored"></i>
            },
            
        ]
    },
    {
        type: 'Databases',
        list: [
            {
                name: 'Postgre SQL',
                icon: <i class="devicon-postgresql-plain colored"></i>
            },
            {
                name: 'MySQL',
                icon: <i class="devicon-mysql-plain colored"></i>
            },
            {
                name: 'MongoDB',
                icon: <i className="devicon-mongodb-plain colored"></i>
            }
        ]
    },
    {
        type: 'Tools',
        list:[
            {
                name:'HTML5',
                icon: <i className="devicon-html5-plain colored"></i>
            },
            {
                name:'CSS3',
                icon: <i className="devicon-css3-plain colored"></i>
            },
            {
                name: 'git',
                icon: <i className="devicon-git-plain colored"></i>
            },
            {
                name: 'PowerBI',
                icon: <i class="devicon-julia-plain colored"></i>
            },
            {
                name: 'Scikit Learn',
                icon: <i class="devicon-nixos-plain colored"></i>
            },
            {
                name: 'Qlik',
                icon: <i class="devicon-lua-plain colored"></i>
            },
            {
                name: 'Excel',
                icon: <i class="devicon-elm-plain colored"></i>
            },
            {  
                name: 'Tensorflow',
                icon: <i class="devicon-tensorflow-original colored"></i>
            }
        ]
    }
]

export default skillsData